import React from 'react';
import KkpColorBadge from './KkpColorBadge';
import KkpBriefStatusBadge from './KkpBriefStatusBadge';
import { getVenteBriefStatus } from '../../utils/kkpVenteBriefUtils';
import { formatBatValideDepuisLabel } from '../../utils/kkpDateFormat';

/**
 * Badge statut phase + date BAT Validé condensée + badge brief.
 */
const KkpPlanningStatutDisplay = ({ vente, onBriefClick }) => {
  if (!vente?.statut_phase) {
    return null;
  }

  const briefStatus = getVenteBriefStatus(vente);
  const batDepuis = formatBatValideDepuisLabel(vente.bat_valide_at, vente.statut_phase);

  return (
    <div className="d-flex flex-wrap align-items-center gap-1">
      <KkpColorBadge color={vente.statut_couleur}>
        {vente.statut_phase}
      </KkpColorBadge>
      {batDepuis ? (
        <span
          className="kkp-statut-bat-depuis"
          title={`BAT Validé depuis ${batDepuis}`}
        >
          {batDepuis}
        </span>
      ) : null}
      {briefStatus ? (
        <KkpBriefStatusBadge
          variant={briefStatus}
          onClick={onBriefClick ? () => onBriefClick(briefStatus) : undefined}
        />
      ) : null}
    </div>
  );
};

export default KkpPlanningStatutDisplay;
